import { render, staticRenderFns } from "./DiscussionBoardGrid.vue?vue&type=template&id=6b0c6750&"
import script from "./DiscussionBoardGrid.vue?vue&type=script&lang=js&"
export * from "./DiscussionBoardGrid.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionBoardGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports